<template>
    <section class="container bg-white my-5 p-5">
        <time-box v-if="belongsToCheckout" :message="timeBoxText"></time-box>

        <alert v-if="!emailVerified"
                message="Du hast deine E-Mail-Adresse noch nicht bestätigt!<br>
                Um unser Angebot voll und ganz nutzen zu können, brauchst du jedoch eine gültige E-Mail-Adresse."
                actionText="Bestätigungsmail erneut zuschicken"
                actionUrl="verificationEmailResendUrl"
                type="info"
        ></alert>

        <div class="row justify-content-center align-items-top" v-if="show">
            <div class="col-12">
                <div class="container-fluid">

                    <div class="row p-1">
                        <div class="col-md-6">
                            <strong class="h5">Ich möchte selbst beim Händler abholen:</strong>
                        </div>
                        <div class="col-md-6">
                            <strong class="h5">Ich möchte mein Auto nach Hause geliefert bekommen:</strong><br>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-md-6">
                            <div class="container-fluid">
                                <div class="row">
                                    <p class="col-7">
                                        {{ subscription.producer.name }} <br>
                                        {{ subscription.producer.address.street }} {{ subscription.producer.address.house_number }}<br>
                                        {{ subscription.producer.address.postal_code }} {{ subscription.producer.address.city }}
                                    </p>
                                    <img src="https://fakeimg.pl/200x50/" alt="" class="img-fluid col-5">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <p>
                                <strong>Deine Lieferadresse:</strong> <br>
                                {{ subscription.consumer.first_name }} {{ subscription.consumer.last_name }}<br>
                                {{ subscription.consumer.address.company }}<br>
                                {{ subscription.consumer.address.street }} {{ subscription.consumer.address.house_number
                                }}<br>
                                {{ subscription.consumer.address.postal_code }} {{ subscription.consumer.address.city }}
                            </p>
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-12">
                            <map-navigation v-if="show" :origin="subscription.consumer.address" :destination="subscription.producer.address"></map-navigation>
                        </div>
                        <form class="col-12" v-on:submit.prevent="formSubmit" :action="formAction">
                            <div class="row">
                                <div class="col-12 col-md-6 text-center">
                                    <button type="button" class="btn btn-outline-secondary" v-on:click="selectPickUp">Ich möchte abholen</button>
                                </div>
                                <div class="col-12 col-md-6 text-center">
                                    <button type="button" class="btn btn-primary" v-on:click="selectDelivery">Lieferung wählen</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Handover",
        props: ['belongsToCheckout', 'subscriptionData', 'emailVerified', 'nextUrl', 'formAction'],
        data() {
            return {
                timeBoxText: "Wie möchten Sie ihr Auto in Empfang nehmen? Heimlieferung oder Abholung im Betrieb in Ihrer Nähe?",
                subscription: {},
                show: false,
            };
        },
        methods: {
            parseSubscriptionData() {
                this.subscription = JSON.parse(this.subscriptionData);
                this.subscription.consumer.address.additional = JSON.parse(this.subscription.consumer.address.additional);
                this.subscription.details = JSON.parse(this.subscription.details);
                //this.subscription.producer.location = JSON.parse(this.subscription.producer.location);
                this.subscription.vehicle.filter_attributes = JSON.parse(this.subscription.vehicle.filter_attributes);
                this.show = true;
            },
            async selectPickUp(){
                await this.setDeliveryMethod('pickup');
            },
            async selectDelivery(){
                await this.setDeliveryMethod('delivery');
            },
            async setDeliveryMethod(method){
                let self = this;
                axios.post(this.formAction, {
                    deliveryMethod: method
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }).then(function(result){
                    window.location.href = result.data.nextUrl;
                }).catch(function(error){
                    console.error(error);
                });
            }
        },
        computed: {
            origin(){
                    return subscription.consumer.address.street + " " + subscription.consumer.address.house_number +
                        + " " + subscription.consumer.address.postal_code + " " + subscription.consumer.address.city;

            },
            destination(){
                    return this.subscription.producer.location.address;
            }
        },
        mounted() {
            this.parseSubscriptionData();
        }
    }
</script>

<style scoped>

</style>
